import { graphql } from "../gql";

export const updateSsoDomainIdentityProviderMutationDoc = graphql(`
  mutation updateSsoDomainIdentityProvider(
    $input: UpdateSsoDomainIdentityProviderInput!
  ) {
    updateSsoDomainIdentityProvider(input: $input) {
      ssoDomainIdentityProvider {
        id
        domain
        environment
        tenantId
        config
        isActive
        updatedAt
        __typename
      }
    }
  }
`);
